const toSection = (data) => ({
  hidden: !!data.hidden,
  versions: [],
  ...data,
  content: data.content ? JSON.parse(data.content) : null,
});

export default toSection;
